export default "__VITE_ASSET__7d6143b5__"